var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_60407",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_60407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1336 28.9C22.4222 28.9 20.9555 28.2891 19.7336 27.0672C18.5112 25.8448 17.9 24.3891 17.9 22.7C17.9 20.9667 18.5112 19.4891 19.7336 18.2672C20.9555 17.0448 22.4222 16.4336 24.1336 16.4336C25.8446 16.4336 27.3168 17.0448 28.5504 18.2672C29.7835 19.4891 30.4 20.9667 30.4 22.7C30.4 24.3891 29.7835 25.8448 28.5504 27.0672C27.3168 28.2891 25.8446 28.9 24.1336 28.9ZM23.5 23.3672V26.2336C23.5 26.4112 23.5723 26.5667 23.7168 26.7C23.8614 26.8333 24.0224 26.9 24.2 26.9C24.3776 26.9 24.5331 26.828 24.6664 26.684C24.7998 26.5395 24.8664 26.3781 24.8664 26.2V23.3672H27.7336C27.9112 23.3672 28.0667 23.3005 28.2 23.1672C28.3334 23.0339 28.4 22.8781 28.4 22.7C28.4 22.5 28.3334 22.3389 28.2 22.2168C28.0667 22.0947 27.9112 22.0336 27.7336 22.0336H24.8664V19.1672C24.8664 18.9891 24.7998 18.8333 24.6664 18.7C24.5331 18.5667 24.3776 18.5 24.2 18.5C24.0224 18.5 23.8614 18.5667 23.7168 18.7C23.5723 18.8333 23.5 18.9891 23.5 19.1672V22.0336H20.6336C20.4555 22.0336 20.2998 22.0947 20.1664 22.2168C20.0331 22.3389 19.9664 22.5 19.9664 22.7C19.9664 22.8781 20.0387 23.0339 20.1832 23.1672C20.3278 23.3005 20.4888 23.3672 20.6664 23.3672H23.5ZM16.7336 26.5H7.73365C7.06698 26.5 6.49472 26.2611 6.01685 25.7832C5.53898 25.3059 5.30005 24.7339 5.30005 24.0672V11.6336C5.30005 11.256 5.38352 10.8949 5.55045 10.5504C5.71685 10.2059 5.95552 9.9224 6.26645 9.7L14.5336 3.5C14.9779 3.16667 15.4667 3 16 3C16.5334 3 17.0222 3.16667 17.4664 3.5L25.7336 9.7C26.0446 9.9224 26.2832 10.2059 26.4496 10.5504C26.6166 10.8949 26.7 11.256 26.7 11.6336V14.7336C26.3224 14.6003 25.928 14.4947 25.5168 14.4168C25.1056 14.3389 24.6888 14.3 24.2664 14.3C21.9112 14.3 19.9112 15.1112 18.2664 16.7336C16.6222 18.356 15.8 20.3339 15.8 22.6672C15.8 23.3339 15.8779 23.9893 16.0336 24.6336C16.1888 25.2779 16.4222 25.9 16.7336 26.5Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.4f160c907ba28c90bbc042f43f9468da.svg";
export { ForwardRef as ReactComponent };